import Vue from "vue";
import axios from "axios";
import "../../../../filters";
import moment from "moment";
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import {
  DxTextBox,
  DxCheckBox,
  DxNumberBox,
  DxDateBox,
  DxTextArea,
  DxSelectBox,
  DxRadioGroup,
  DxSwitch,
} from "devextreme-vue";
import users from "../../../../users";
import { sanitizeNumber } from "@/utils";

import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";

const toLower = (text) => {
  return text.toString().toLowerCase();
};

const searchBookByText = (items, term) => {
  if (term != "") {
    return items.filter((item) => toLower(item.text).includes(toLower(term)));
  }

  return items;
};

const searchWalkByText = (items, term) => {
  if (term) {
    return items.filter((item) => toLower(item.text).includes(toLower(term)));
  }

  return items;
};

export default {
  name: "CaptureCustomer",
  mixins: [users, validationMixin],
  components: {
    FormWizard,
    TabContent,
    DxTextBox,
    DxCheckBox,
    DxNumberBox,
    DxDateBox,
    DxTextArea,
    DxSelectBox,
    DxRadioGroup,
    DxSwitch,
    DataGridComp: require("../../../../customcontrols/datagrid.vue").default,
    selectCustomerComp:
      require("../../../selectCustomerComp/selectCustomerComp.vue").default,
    AddressComp:
      require("@/components/addressCodedUncoded/addressCodedUncoded.vue")
        .default,
    ExistingAccountData:
      require("@/components/existingAccountData/existingAccountData.vue")
        .default,
    dateTimePickerComp: require("../../../../customcontrols/dateTimePicker.vue")
      .default,
  },
  props: ["dataObj"],
  data: function () {
    let dateFormat = this.$material.locale.dateFormat || "yyyy-MM-dd";
    return {
      customerFilters: null,
      addressDataObj: null,
      appId: -1,
      searchBook: "",
      personCompany: [
        { id: 0, text: this.$t("activities.individual") },
        { id: 1, text: this.$t("activities.company") },
      ],
      personCompanyModel: 0,
      stmtDeliveryMethods: [
        { id: "0", text: this.$t("activities.assignedToWalkroute") }, // 'Assigned to Walkroute' },
        { id: "1", text: this.$t("activities.partOfGroupAccount") }, // 'Part of Group Account' },
        { id: "2", text: this.$t("activities.reservedAccount") }, // 'Reserved account (non billable)' },
      ],
      stmtDeliveryMethod: "0",
      exceptFromPenaltyUntilDateTime2: null,
      birthdayOrIncorporationDateTime2: null,
      linkedAccountsCols: [],
      linkedAccountsKeyColumn: "linkedCustkey",
      linkedAccountSelected: "",
      linkedAccountsCount: 0,
      showSelectCustomer: false,

      addPortalLinkAction: false,
      selectCustomerForOtherTabAction: false,

      currentTab: "tab-general",

      showBookWalk: false,
      showShouldSelectBillingGroup: false,
      selectedBook: "",
      selectedWalk: "",
      selectPrevCustActiveStep: "selectBookWalk",
      bookWalkCustomers: [],
      bookWalkCustomersCols: [],
      searchedBooks: [],
      billGroupBookWalks: [],
    };
  },
  validations: {
    dataObj: {
      generalData: {
        billingGroupId: {
          required,
        },
        consumerType: {
          required,
        },
        surname: {
          required,
          minLength: minLength(5),
        },
      },
      postalData: {
        postalAddress: {
          required,
        },
      },
      detailsData: {
        idNumber: {
          required,
        },
      },
      othersData: {
        bookNumber: {
          required,
        },
        walkNumber: {
          required,
        },
        groupAccountNumber: {
          required,
        },
      },
    },
  },
  computed: {
    billingGroupId() {
      return this.dataObj.generalData.billingGroupId;
    },
    bookNumber() {
      return this.dataObj.othersData.bookNumber;
    },
    walkNumber() {
      return this.dataObj.othersData.walkNumber;
    },
  },
  watch: {
    billingGroupId: {
      handler: function (val, val2) {
        if (val == val2) return;

        this.getBooksWalks();
      },
      deep: true,
    },
    bookNumber: {
      handler: function (val) {
        if (!val) {
          this.selectedBook = "";
        } else {
          if (this.dataObj.books) {
            this.selectedBook =
              this.dataObj.books.filter((a) => a.value == val).length == 0
                ? ""
                : this.dataObj.books.filter((a) => a.value == val)[0].text;
          } else this.selectedBook = val;
        }
      },
      deep: true,
    },
    walkNumber: {
      handler: function (val) {
        if (!val) {
          this.selectedWalk = "";
        } else {
          if (this.dataObj.books) {
            this.selectedWalk =
              this.dataObj.walks.filter((a) => a.value == val).length == 0
                ? ""
                : this.dataObj.walks.filter((a) => a.value == val)[0].text;
          } else this.selectedWalk = val;
        }
      },
      deep: true,
    },
    exceptFromPenaltyUntilDateTime2: function (val) {
      this.dataObj.generalData.exceptFromPenaltyUntilDateTime = moment(
        val,
        "DD/MM/YYYY"
      ).add(1, "days");
    },
    birthdayOrIncorporationDateTime2: function (val) {
      this.dataObj.detailsData.birthdayOrIncorporationDateTime = moment(
        val,
        "DD/MM/YYYY"
      ).add(1, "days");
    },
    searchBook: {
      handler: function (val) {
        if (this.searchBook == "") {
          this.searchedBooks = this.billGroupBooks;
          return;
        }

        this.searchedBooks = searchBookByText(
          this.billGroupBooks,
          this.searchBook
        );
      },
      deep: true,
    },
  },
  created() {
    this.$material.locale.dateFormat = "dd/MM/yyyy";
    this.$root.$on("capture_customer_updated", this.init);

    this.init();
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.fillLinkedAccountsCols();
        this.appId = this.dataObj.appId;

        this.personCompanyModel = this.dataObj.generalData.isCompany ? 1 : 0;
        this.stmtDeliveryMethod =
          this.dataObj.accountTypes.filter((a) => a.selected).length == 0
            ? "0"
            : this.dataObj.accountTypes
                .filter((a) => a.selected)[0]
                .value.toString();

        if (
          this.dataObj.detailsData.birthdayOrIncorporationDateTime >=
          moment("01/01/1900", "DD/MM/YYYY")
        ) {
          this.birthdayOrIncorporationDateTime2 = moment(
            this.dataObj.detailsData.birthdayOrIncorporationDateTime
          ).format("DD/MM/YYYY");
        }

        if (this.dataObj.generalData.billingGroupId != "") {
          this.getBooksWalks();
          /*this.billGroupBooks = this.dataObj.books.filter(a => a.group.name == this.dataObj.generalData.billingGroupId);
          this.searchedBooks = this.billGroupBooks;
          this.searchBook == '';
          this.selectPrevCustActiveStep = 'selectBookWalk';*/
        }

        if (this.dataObj.walks) {
          this.billGroupWalks = this.dataObj.walks.filter(
            (a) => a.group.name == this.dataObj.generalData.billingGroupId
          );
          this.searchedWalks = this.billGroupWalks;
        }

        this.fillBookWalkCustomersCols();

        this.addressDataObj = {
          addressTypes: this.dataObj.addressTypes,
          postalData: this.dataObj.postalData,
        };

        this.customerFilters = {
          consumerTypes: this.dataObj.consumerTypes,
          billingGroups: this.dataObj.billingGroups,
        };
      });
    },
    getValidationClass(data, objName, fieldName) {
      const field = this.$v[data][objName][fieldName];

      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty,
        };
      }
    },
    changeStmtDeliveryMethod(val) {
      for (var i = 0; i < this.dataObj.accountTypes.length; i++) {
        this.dataObj.accountTypes[i].selected = false;
      }

      if (this.dataObj.accountTypes.filter((a) => a.value == val).length > 0) {
        this.dataObj.accountTypes.filter((a) => a.value == val)[0].selected =
          true;
      }
    },
    personCompanyChange(val) {
      if (val == 0) this.dataObj.generalData.isCompany = false;
      else this.dataObj.generalData.isCompany = true;
    },
    validateAppData() {
      this.$v.dataObj.generalData.$touch();

      if (this.dataObj.postalData.addressType == 1) {
        this.$v.dataObj.postalData.$touch();
      }

      this.$v.dataObj.detailsData.$touch();

      if (this.$v.dataObj.generalData.$invalid) {
        this.currentTab = "tab-general";
        return false;
      }

      if (this.dataObj.postalData.addressType == 1) {
        if (this.$v.dataObj.postalData.$invalid) {
          this.currentTab = "tab-postal";
          return false;
        }
      }

      if (this.$v.dataObj.detailsData.$invalid) {
        this.currentTab = "tab-details";
        return false;
      }

      if (this.stmtDeliveryMethod == "0") {
        this.$v.dataObj.othersData.bookNumber.$touch();
        this.$v.dataObj.othersData.walkNumber.$touch();

        if (
          this.$v.dataObj.othersData.bookNumber.$invalid ||
          this.$v.dataObj.othersData.walkNumber.$invalid
        ) {
          this.currentTab = "tab-other";
          return false;
        }
      }

      if (this.stmtDeliveryMethod == "1") {
        this.$v.dataObj.othersData.groupAccountNumber.$touch();

        if (this.$v.dataObj.othersData.groupAccountNumber.$invalid) {
          this.currentTab = "tab-other";
          return false;
        }
      }

      return true;
    },

    addPortalLinkedAccount() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
      };
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/CaptureCustomerActivity/AddPortalLinkedAccount", parameter)
        .then((response) => {
          if (response.status == 200) {
          } else {
            this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    removePortalLinkedAccount() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
      };
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/CaptureCustomerActivity/RemovePortalLinkedAccount", parameter)
        .then((response) => {
          if (response.status == 200) {
          } else {
            this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    initiateFromExistingAccount() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
      };
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/CaptureCustomerActivity/InitiateFromExistingAccount", parameter)
        .then((response) => {
          if (response.status == 200) {
          } else {
            this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    getChanges() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
      };
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/CaptureCustomerActivity/GetChanges", parameter)
        .then((response) => {
          if (response.status == 200) {
          } else {
            this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    positionInCustomerWalkroute() {
      this.selectCustomerForOtherTabAction = true;
      this.showSelectCustomer = true;
    },
    validateIBAN() {
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/CaptureCustomerActivity/ValidateIBAN", {
          Value: this.dataObj.othersData.bankAccountIBAN,
        })
        .then((response) => {
          if (response.status == 200) {
            if (response.data.item) {
              this.$alertMsg(this.$t("messages.IBANisCorrect"), 2);
            } else {
              this.$alertMsg(this.$t("messages.IBANisIncorrect"));
            }
          } else {
            this.$alertMsg(response.data.data.text);
          }
          loader.hide();
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
        });
    },
    generateDirectDebitAcctNo() {},
    fillLinkedAccountsCols() {
      this.linkedAccountsCols.push({
        dataField: "linkedCustkey",
        caption: this.$t("activities.account"),
      });
      this.linkedAccountsCols.push({
        dataField: "name",
        caption: this.$t("activities.name"),
      });
    },
    addLinkedAccount() {
      this.addPortalLinkAction = true;
      this.showSelectCustomer = true;
    },
    removeLinkedAccount() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        CustomerKey: this.linkedAccountSelected,
      };
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/CaptureCustomerActivity/RemovePortalLinkedAccount", parameter)
        .then((response) => {
          if (response.status == 200) {
            this.dataObj.portalLinkedAccounts.length = 0;
            this.dataObj.portalLinkedAccounts = response.data;

            this.linkedAccountsCount = response.data.length;
            this.$alertMsg(
              this.$t("messages.RemovePortalLinkedAccountSuccess"),
              2
            );
            loader.hide();
            return true;
          } else {
            this.$alertMsg(
              this.$t("messages.RemovePortalLinkedAccountFailure")
            );
            loader.hide();
            return false;
          }
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
          return false;
        });
    },
    viewLinkedAccount() {
      if (this.linkedAccountSelected === "") return;

      let routeData = this.$router.resolve({
        name: "customer",
        params: { custkey: this.linkedAccountSelected },
      });
      window.open(routeData.href, "_blank");
    },
    selectLinkedAccount(info) {
      if (info === null || info === undefined) return;

      this.linkedAccountSelected =
        info.rows[info.newRowIndex].data.linkedCustkey;
    },
    selectCustomerDone(custkey) {
      this.showSelectCustomer = false;
      if (this.addPortalLinkAction) {
        this.addPortalLinkAction = false;
        this.addLinkedAccountAction(custkey);
      }

      if (this.selectCustomerForOtherTabAction) {
        this.selectCustomerForOtherTabAction = false;
        this.positionInCustomerWalkrouteAction(custkey);
      }
    },
    addLinkedAccountAction(custkey) {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        CustomerKey: custkey,
      };
      let loader = this.$loading.show({
        color: "#23348d",
        loader: "dots",
        width: 256,
        height: 256,
        backgroundColor: "#ffffff",
        opacity: 0.5,
      });
      axios
        .post("/CaptureCustomerActivity/AddPortalLinkedAccount", parameter)
        .then((response) => {
          if (response.status == 200) {
            this.dataObj.portalLinkedAccounts.length = 0;
            this.dataObj.portalLinkedAccounts = response.data;
            this.linkedAccountsCount = response.data.length;

            this.$alertMsg(
              this.$t("messages.AddPortalLinkedAccountSuccess"),
              2
            );
            loader.hide();
            return true;
          } else {
            this.$alertMsg(this.$t("messages.AddPortalLinkedAccountFailure"));
            loader.hide();
            return false;
          }
        })
        .catch((error) => {
          loader.hide();
          this.$alertMsg(error.response.data);
          return false;
        });
    },
    positionInCustomerWalkrouteAction(custkey) {
      this.dataObj.othersData.groupAccountNumber = custkey;
    },
    positionInBookWalk() {
      if (this.dataObj.generalData.billingGroupId == "") {
        this.showShouldSelectBillingGroup = true;
        this.currentTab = "tab-general";
        return;
      }

      if (parseInt(this.dataObj.generalData.billingGroupId) <= 0) {
        this.showShouldSelectBillingGroup = true;
        this.currentTab = "tab-general";
        return;
      }

      this.showBookWalk = true;
    },
    changeTab(e) {
      this.currentTab = e;
    },
    selectBook(book) {
      //if (book == null)
      //  return;

      this.dataObj.othersData.bookNumber = book.value;
      this.selectedBook = book.text;
      //this.searchBook = book.text;
    },
    selectWalk(walk) {
      //if (walk == null)
      //  return;

      this.dataObj.othersData.walkNumber = walk.value;
      this.selectedWalk = walk.text;
      //this.searchWalk = walk.text;
    },
    selectBookWalk() {
      if (this.dataObj.othersData.bookNumber == "") {
        this.$alertMsg(this.$t("validation.requiredBookNo"));
        return;
      }

      if (this.dataObj.othersData.walkNumber == "") {
        this.$alertMsg(this.$t("validation.requiredWalkNo"));
        return;
      }

      this.getCustomersByBookWalk();
    },
    getCustomersByBookWalk() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Book: this.dataObj.othersData.bookNumber,
        Walk: this.dataObj.othersData.walkNumber,
      };

      this.$store.state.notifier.asyncBlock(
        axios.post(
          "/CaptureCustomerActivity/GetCustomersByBookWalk",
          parameter
        ),
        (resp) => {
          if (resp.status == 200) {
            this.bookWalkCustomers = resp.data.items;
            this.selectPrevCustActiveStep = "selectPrevCustomer";
          } else this.$alertMsg(resp.data.data.text);
        },
        (err) => {
          this.$alertMsg(err.response.data);
        }
      );
    },
    fillBookWalkCustomersCols() {
      this.bookWalkCustomersCols = [];

      this.bookWalkCustomersCols.push({
        dataField: "customerKey",
        caption: this.$t("activities.customerKey"),
      });
      this.bookWalkCustomersCols.push({
        dataField: "name",
        caption: this.$t("activities.surname"),
      });
      this.bookWalkCustomersCols.push({
        dataField: "address",
        caption: this.$t("activities.address"),
      });
    },
    selectPrevCustomer(info) {
      this.dataObj.othersData.previousCustomerKey = info.key; //this.bookWalkCustomers[info.rowIndex].customerKey;

      this.showBookWalk = false;
    },
    searchBookText() {
      //b in dataObj.books.filter(a => a.group.name == dataObj.generalData.billingGroupId)
      if (this.searchBook == "") {
        this.searchedBooks = this.billGroupBooks;
        return;
      }

      this.searchedBooks = searchBookByText(
        this.billGroupBooks,
        this.searchBook
      );
    },
    searchWalkText() {
      if (this.searchWalk == "") {
        this.searchedWalks = this.billGroupWalks;
        return;
      }

      this.searchedWalks = searchWalkByText(
        this.billGroupWalks,
        this.searchWalk
      );
    },
    getBooksWalks() {
      axios
        .get(
          "/CaptureCustomerActivity/GetBooksWalks?billingGroupId=" +
            this.dataObj.generalData.billingGroupId
        )
        .then((resp) => {
          if (resp.status == 200) {
            this.billGroupBooks = resp.data.books;
            this.billGroupBookWalks = resp.data.walks;

            this.searchedBooks = this.billGroupBooks;
            this.searchBook == "";
            this.selectPrevCustActiveStep = "selectBookWalk";

            //this.dataObj.othersData.bookNumber = '';
            //this.dataObj.othersData.walkNumber = 0;

            if (
              this.dataObj.othersData.bookNumber == "" ||
              this.dataObj.othersData.bookNumber == null ||
              !this.searchedBooks ||
              this.searchedBooks.length == 0
            ) {
              this.selectedBook = "";
            } else {
              let temp = this.searchedBooks.filter(
                (a) => a.value == this.dataObj.othersData.bookNumber
              );
              this.selectedBook = temp && temp.length ? temp[0].text : "";
            }

            this.searchBook = this.selectedBook;

            // console.log("jdjdjd", this.dataObj.othersData.walkNumber);
            // if (
            //   this.dataObj.othersData.walkNumber == 0 ||
            //   !this.billGroupBookWalks ||
            //   this.billGroupBookWalks.length == 0
            // ) {
            //   this.selectedWalk = "";
            // } else {
            //   let temp = this.billGroupBookWalks.filter(
            //     (a) => a.value == this.dataObj.othersData.walkNumber
            //   );
            //   this.selectedWalk = temp && temp.length ? temp[0].text : "";
            // }

            this.searchWalk = this.selectedWalk;
          } else this.$alertMsg(resp.data.data.text);
        })
        .catch((err) => {
          console.log("err", err);
          this.$alertMsg(err.response.data);
        });
    },

    customerSelected(cust) {
      // console.log("cust", cust);

      this.dataObj.generalData = {
        ...this.dataObj.generalData,

        accountType: cust.accountType ?? this.dataObj.accountTypes[0].value,
        // account: cust.customerKey,
        surname: cust.surname,
        title: cust.title,
        initial: cust.initial,
        telephoneNumber: cust.telephoneNumber,
        cellPhoneNumber: cust.cellPhone,
        emailAddress: cust.email,
        workTelephoneNumber: cust.workTelNo,
        faxNumber: cust.faxNo,
        idNumber: cust.idNumber,
        pin: cust.pin,
        consumerType: cust.consumerType,
        // customerKey: cust.customerKey,
        taxNumber: cust.taxNo,
        oldCustomerKey: cust.oldAccountNo, // cust.previousCustomerKey,
        noSms: cust.consentReceiveSms == true,
        gender: sanitizeNumber(cust.gender),
        isCompany: cust.isCompany == true,
        companyName: cust.companyName,
        companyTelephoneNumber: cust.companyTelephoneNumber,
        recurringAccount: cust.recurringAccount == true,
        useOpenItemConcept: cust.useOpenItemConcept == true,
        exceptFromVAT: cust.exceptFromVAT == true,
        exceptFromPenalty: cust.exceptFromPenalty == true,
        exceptFromPenaltyUntilDateTime: cust.exceptFromPenaltyUntilDateTime,
      };

      if (this.dataObj.newCustomerBillingGroupId)
        this.dataObj.generalData.billingGroupId =
          this.dataObj.newCustomerBillingGroupId;

      this.dataObj.detailsData = {
        ...this.dataObj.detailsData,

        faxNumber: cust.faxNo,
        vatNumber: cust.vatNo,
        taxNumber: cust.taxNo,
        email: cust.email,
        idNumber: cust.idNumber,
        idTypeId: sanitizeNumber(cust.idTypeId),
        pin: cust.pin,
        birthdayOrIncorporationDateTime: cust.birthDate,
        dsoContactId: cust.dsoContactId,
        // dsoCategory: cust.dsoCategory,
        // dsoBaseCategory: cust.dsoBaseCategory,
        consentToSms: cust.consentReceiveSms == true,
        consentToEmail: cust.consentReceiveEmail == true,
        statementDeliveryTypeId: sanitizeNumber(cust.statementDeliveryTypeId),
        statementEmail: cust.statementEmail,
        employerName: cust.companyName,
        employerTelephoneNumber: cust.companyTelephoneNumber,
      };

      this.dataObj.postalData = {
        ...this.dataObj.postalData,

        addressType: sanitizeNumber(cust.addressType),
        careOf: cust.careOf,
        code: cust.code,
        flatName: cust.flatName,
        flatNumber: cust.flatNumber,
        houseNumber: cust.houseNumber,
        buildingName: cust.buildingName,
        postalAddress: cust.postalAddress,
        ownerAddress: cust.ownerAddress,
        contact: cust.contact,
        ownerFullName: cust.ownerFullName,
        personalAddressType: sanitizeNumber(cust.personalAddressType),
        personalCareOf: cust.personalCareOf,
        personalCode: cust.personalCode,
        personalFlatName: cust.personalFlatName,
        personalFlatNumber: cust.personalFlatNumber,
        personalHouseNumber: cust.personalHouseNumber,
        personalBuildingName: cust.personalBuildingName,
        personalPostalAddress: cust.personalPostalAddress,
        personalOwnerAddress: cust.personalOwnerAddress,
        personalContact: cust.personalContact,
        personalOwnerFullName: cust.personalOwnerFullName,
      };

      this.addressDataObj.postalData = this.dataObj.postalData;

      this.dataObj.othersData = {
        ...this.dataObj.othersData,

        walkNumber: sanitizeNumber(cust.walkNumber),
        bookNumber: cust.bookNumber,
        previousCustomerKey: cust.previousCustomerKey,
        groupAccountNumber: cust.groupAccountNumber,
        departmentCode: cust.departmentCode,
        infoFlag1: cust.infoFlag1,
        infoFlag2: cust.infoFlag2,
        infoFlag3: cust.infoFlag3,
        infoFlag4: cust.infoFlag4,
        infoFlag5: cust.infoFlag5,
        bankId: cust.bankId,
        paymentTypeMethod: sanitizeNumber(cust.paymentTypeMethod),
        bankAccountIBAN: cust.bankAccountIBAN,
        directDebitAccountNumber: cust.directDebitAccountNumber,
        directDebitAmount: sanitizeNumber(cust.directDebitAmount),
      };

      this.selectedWalk = sanitizeNumber(cust.walkNumber);
    },
  },
};
